import type {
	DetailTranslations,
	InvoiceTranslations,
	MutationTranslations,
	SharedTranslations,
	TableTranslations,
} from "Infrastructure/Translation/Types/invoice";

const tableTranslations: TableTranslations = {
	id: "ID",
	totalAmountWithoutVat: "Total amount",
	totalVatAmount: "Total VAT",
	totalVatPercentage: "Total VAT percentage",
	totalAmountWithVat: "Total amount including VAT",
	totalDeposit: "Total deposit",
	customerDebt: "Customer debt",
	invoiceNumber: "Number",
	variableSymbol: "Variable symbol",
	status: "Status",
	bankName: "Bank name",
	bankAccount: "Account number",
	iban: "IBAN",
	paymentMethod: "Payment method",
	dateIssued: "Date issued",
	dateDue: "Date due",
	supplierName: "Supplier name",
	supplierBusinessId: "Supplier business ID",
	supplierVatId: "Supplier VAT ID",
	supplierVatLiable: "Supplier VAT liable",
	supplierStreet: "Supplier street",
	supplierBuildingNumber: "Supplier building number",
	supplierPostCode: "Supplier post code",
	supplierCity: "Supplier city",
	customerName: "Customer name",
	customerBusinessId: "Customer business ID",
	customerVatId: "Customer VAT ID",
	customerVatLiable: "Customer VAT liable",
	customerStreet: "Customer street",
	customerBuildingNumber: "Customer building number",
	customerPostCode: "Customer post code",
	customerCity: "Customer city",
	customer: "Customer",
	supplier: "Supplier",
	datePaid: "Date paid",
	order: "Order ID",
};

const detailTranslations: DetailTranslations = {
	customer: "Customer",
	businessId: "Business ID",
	vatId: "VAT ID",
	vatLiable: "VAT liable",
	from: "From",
	name: "Name",
	count: "Count",
	unitPrice: "Unit price",
	totalPrice: "Total price",
	vat: "VAT",
	totalPriceVatIncluded: "Total price including VAT",
	totalPriceVatNotIncluded: "Total price excluding VAT",
	totalAmount: "Total amount",
	totalVat: "Total VAT",
	totalAmountVatIncluded: "Total amount including VAT",
	dateDue: "Date due",
	dateIssued: "Date issued",
	issued: "Issued",
	datePaid: "Date paid",
	paid: "Paid",
	bankAccount: "Bank account",
	bankName: "Bank name",
	iban: "IBAN",
	paymentMethod: "Payment method",
	variableSymbol: "Variable symbol",
	status: "Status",
	downloadInvoice: "Download",
	regenerateInvoice: "Regenerate",
	partner: "Partner",
	order: "Order",
	actions: "Actions",
	customerDebt: "Customer debt",
	partnerName: "Partner name",
	partnerBusinessId: "Partner business ID",
	partnerAddress: "Partner address",
};

const sharedTranslations: SharedTranslations = {
	actions: "Actions",
	isVatLiable: "Yes",
	isNotVatLiable: "No",
	heading: "Payment requests",
};

const mutationTranslations: MutationTranslations = {
	updateInvoiceSuccess: "Payment request updated successfully",
	updateInvoiceError: "Error updating payment request",
};

export const invoiceTranslations: InvoiceTranslations = {
	table: tableTranslations,
	detail: detailTranslations,
	shared: sharedTranslations,
	mutation: mutationTranslations,
};
